export default "__VITE_PUBLIC_ASSET__1e981688__"